/* eslint-disable react/prop-types */
import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { useSelector } from 'react-redux';

const PrivateRoute = ({ component: Component, ...rest }) => {
    const sessionState = useSelector(state => state.session);
    // Add your own authentication on the below line.
    const isLoggedIn = sessionState.loggedIn

    return (
        <Route {...rest} render={props =>
            !isLoggedIn ? (
                <Redirect to="/auth/login" />
            ) : (
                <Component {...props} />
            )
        }
        />
    )
}

export default PrivateRoute